import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { nameToHash, theme } from '@arc/frontend/ui-theme';
import { useQueryUserOptions } from '@arc/frontend/util-users';
import { FILTER_OPTION_MINE, FILTER_OPTION_NONE } from '@arc/shared/util-filters';
import { MultiselectWithControl } from '../Multiselect';
export function SelectorUsersWithControl({
  includeNone,
  includeMine,
  indicateNoPhoneNumber,
  extraOptions,
  ...multiselectWithControlProps
}) {
  const {
    t
  } = useTranslation('email-sms');
  const {
    data,
    isPending
  } = useQueryUserOptions();
  const userList = data?.items;
  const itemList = useMemo(() => {
    const items = [];
    if (includeNone) {
      items.push({
        userNone: true,
        name: FILTER_OPTION_NONE
      });
    }
    if (includeMine) {
      items.push({
        userMine: true,
        name: FILTER_OPTION_MINE
      });
    }
    if (extraOptions) {
      items.push(...extraOptions.map(option => ({
        ...option,
        extraOption: true
      })));
    }
    return [...items, ...(userList ?? [])];
  }, [includeMine, includeNone, extraOptions, userList]);
  return <MultiselectWithControl {...multiselectWithControlProps}
  // search={search}
  // setSearch={setSearch}
  options={itemList} isLoading={isPending} getOptionLabel={option => {
    if (option.userNone) {
      return t('email-sms:User none');
    } else if (option.userMine) {
      return 'Mine';
    } else {
      return option.name;
    }
  }} getOptionColor={option => {
    if (option.userNone) {
      return theme.colors.specialOptions.none;
    } else if (option.userMine) {
      return theme.colors.specialOptions.mine;
    } else if (option.extraOption) {
      return nameToHash(option.name);
    } else {
      return undefined;
    }
  }} isOptionEqualToValue={(option, value) => {
    if (option.userNone) {
      return !!value.userNone;
    } else if (option.userMine) {
      return !!value.userMine;
    } else {
      return option.id === value.id;
    }
  }} />;
}